import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query searchArticles($searchTerm: String, $limit: Int, $page: Int) {
    searchArticles(searchTerm: $searchTerm, limit: $limit, page: $page) {
      totalDocs
      page
      docs {
        id
        title
        shortDescription
        featuredImage {
          id
          url
        }
        primaryCategory {
          name
          slug
        }
        slug
      }
    }
  }
`

export interface SearchArticlesQueryInput {
  searchTerm: string
  limit: number
  page: number
}

const defaultVariables: SearchArticlesQueryInput = {
  searchTerm: '',
  limit: 9,
  page: 1,
}

export interface SearchArticlesQueryOutput {
  searchArticles: {
    totalDocs: number
    page: number
    docs: {
      id: string
      title: string
      shortDescription: string
      featuredImage: {
        url: string
        alt: string
      }
      primaryCategory: {
        name: string
        slug: string
      }
      slug: string
    }[]
  }
}

export const useSearchArticlesQuery = (options: QueryHookOptions<SearchArticlesQueryOutput, SearchArticlesQueryInput>) =>
  usePersistedCacheQuery<SearchArticlesQueryOutput, SearchArticlesQueryInput>(query, {
    ...options
  })


export const searchArticlesQuery = { query, defaultVariables }
